// src/com/rtd_term_pos/RtdTermPosGql.js
import { gql } from "@apollo/client";
import { SESSION_USER } from "../login/AppLoginGql";

const RTD_TERM_POS_LIST_PART = gql`
fragment RtdTermPosListPart on RtdTermPos {
    termId
    vehInfoSeq
    vehPlates
    vehAlias
    gpsTime
    reportAgeSec
    xDist
    yDist
    location
    speed
    distKm
    direction
    statusCode
    eventCd
    svcCondCd
    loadCondCd
    pwrType
    posSys
    lat
    lon
    cycleMake
    cycleReport
    doorEvent
    door0
    door1
    door2
    tempr1
    tempr2
    tempr3
    tempr4
    itinRepType
    irAction
    irActionName
    vehTypeName
    vehTonName
    driverName
    driverMobile
    operFontColor
    operBackColor
    noOperFontColor
    noOperBackColor
    offFontColor
    offBackColor
    doorSensors
    comName
    comAlias
    comId
    custId
}
`;

const RTD_TERM_POS_NO_LIST_PART = gql`
fragment RtdTermPosNoListPart on RtdTermPos {
    devId
    vehId
    recvTime
    insertTime
    gpioBits
    addrPrefix
    poiName
    poiDistM
    roadName
    roadRank
    roadMaxSpeed
}
`;

export const LIST_RTD_TERM_POS = gql`
${RTD_TERM_POS_LIST_PART}
query ListRtdTermPos {
    rtdTermPosList {
        ...RtdTermPosListPart
    }
}
`;

// 지도용 조회: 같은 차량이 서로 다른 업체에 등록되어 있을 수 있으므로 그 중 하나만 표시하기 위해서.
// 차량위치와 함께 세션 데이터를 같이 조회하여 센터전환 되었는지 확인한다.
export const LIST_RTD_TERM_POS_FOR_MAP = gql`
${RTD_TERM_POS_LIST_PART}
${SESSION_USER}
query ListRtdTermPosForMap {
    rtdTermPosListForMap {
        ...RtdTermPosListPart
    }
    getSessionData {
        ...SessionUserData
    }
}
`;

// rtdTermPosListForStore: [RtdTermPos]!
// 점포사용자용 지도용 조회
export const LIST_RTD_TERM_POS_FOR_STORE = gql`
${RTD_TERM_POS_LIST_PART}
${SESSION_USER}
query ListRtdTermPosForStore {
    rtdTermPosListForStore {
        ...RtdTermPosListPart
    }
    getSessionData {
        ...SessionUserData
    }
}
`;


export const GET_RTD_TERM_POS = gql`
${RTD_TERM_POS_LIST_PART}
${RTD_TERM_POS_NO_LIST_PART}
query GetRtdTermPos($vehInfoSeq:Int!) {
    rtdTermPosItem(vehInfoSeq:$vehInfoSeq) {
        ...RtdTermPosListPart
        ...RtdTermPosNoListPart
    }
}
`;

/*

        SELECT
            c.com_name AS comName,
            tv.com_id AS comId,
            tv.veh_plates AS vehPlates,
            fn_decrypt(tv.driver_name) AS driverName,
            fn_decrypt(tv.driver_mobile) AS driverMobile,
            r.gps_time AS gpsTime
        FROM (
            SELECT
                DISTINCT t.com_id, t.veh_plates, t.driver_name, t.driver_mobile
            FROM trans_plan t, veh_info v
            WHERE t.plan_date=fn_today(-1)
                AND t.req_state_flag='2'
                AND v.veh_plates=t.veh_plates
                AND v.rent_yn='N'
                AND v.term_id IS NOT NULL
        ) tv, rtd_term_pos r, com_info c
        WHERE c.com_id=tv.com_id
        AND r.cust_id=tv.com_id AND r.veh_plates=tv.veh_plates
        AND r.gps_time &lt; fn_today(#{daysAgo})
*/
// rtdTermPosListNoReport(daysAgo:Int!): [RtdTermPos]!
export const LIST_RTD_TERM_POS_NO_REPORT = gql`
query ListRtdTermPosNoReport($daysAgo:Int!) {
    rtdTermPosListNoReport(daysAgo:$daysAgo) {
        vehInfoSeq
        comName
        comId
        vehPlates
        driverName
        driverMobile
        gpsTime
    }
}
`;
